export const ERR_GATEWAY_CONN_EXISTS = 'payment_gateway_entity_exists';

export const CONNECTION_STATUS = {
  Active: 'active',
  Inactive: 'inactive',
  Processing: 'processing',
};

export const GATEWAY_ENVIRONMENTS = {
  Production: 'production',
  Sandbox: 'sandbox',
};
